/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { getDisplayName } from './getDisplayName';

export function wrapDisplayName(Component: React.ComponentType<any>, hocName: string): string {
  return `${hocName}(${getDisplayName(Component)})`;
}
